$(() => {
    if (document.getElementById('filter') != null) {
        $('.js-all_contracts').on('change', function(e) {
            $('.js-filter-button').prop('disabled', false);
            $('#all_contracts').val($(this).val());
            $('#filter').submit();
        });
        // 期間外        
        $('#checkbox-out_operation').on('change', function(e) {
            if ($('#checkbox-out_operation').prop('checked')) {
                $('#out_operation').val(1);
            } else {
                $('#out_operation').val(0);
            }
            $('#filter').submit();
        });
    }
});
